import React from 'react';
import get from 'lodash/get';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookCurrencyInputWrapper } from 'src/components/CookbookCurrencyInputWrapper/CookbookCurrencyInputWrapper';

export interface MembershipFeerops {
  name: string;
  id: string;
}

export function MembershipFeeControl({
  name,
  id,
}: MembershipFeerops): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <CookbookCurrencyInputWrapper
      name={name}
      id={id}
      control={control}
      error={get(errors, name)}
      currency="USD"
      locale="en-US"
      suffixDecorator="/month"
      aria-label={name}
      inputSize="medium"
      blockWidth
      label="Monthly membership fee *"
      placeholder="e.g. $3.00"
      rules={{
        required: 'Monthly membership fee is required',
      }}
    />
  );
}
